import { render, staticRenderFns } from "./Web.vue?vue&type=template&id=7ca78d2c&"
import script from "./Web.vue?vue&type=script&lang=ts&"
export * from "./Web.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports